exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!../../sass/_global_variables.scss"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3bddf854!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/csrf-token.vue
// module id = IOIX
// module chunks = 0